import { Slot, Stack } from "expo-router";
// @ts-expect-error baseline 2026-02-16
import { WebLayout } from "@src/components/web";

export default function ReportsWebLayout() {
  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <WebLayout>
        <Slot />
      </WebLayout>
    </>
  );
}
